import { OrganizationOnboardingRepositoryDTO } from '../../domain/onboarding/OrganizationOnboardingRepositoryDTO';
import { Organization } from '../../domain/organization/Organization';

export class OrganizationOnboardingMapper {
  static toRepository(organization: Organization): OrganizationOnboardingRepositoryDTO {
    const { label, num_of_vehicles } = organization.props;
    return {
      label,
      num_of_vehicles,
    };
  }
}
